<template>
    <nav id="nav">
        <div class="content">
            <div class="logo" @click="mcdonaldsPage()"></div>

            <div class="text" v-if="isClientInformation">
                {{ $t('public.nav.text1') }} <b>{{ $t('public.nav.text2') }}</b>
            </div>

            <select class="select-language" v-model="language" @change="onLanguageChange">
                <option value="es">Español</option>
                <option value="ca">Catalán</option>
            </select>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'Nav',
    data() {
        return {
            language: 'es',
        }
    },
    computed: {
        step: {
            get: function () {
                return this.$store.getters['form/getStep']
            }
        },
        isClientInformation: {
            get: function () {
                return this.$store.getters['form/isClientInformation']
            }
        }
    },
    mounted() {
        this.language = this.$i18n.locale
    },
    methods: {
        mcdonaldsPage: function () {
            window.open('https://mcdonalds.es/')
        },

        async onLanguageChange() {
            await this.setLocale(this.language)
        },

        async setLocale(locale) {
            if (this.$i18n.loadLanguageAsync) {
                await this.$i18n.loadLanguageAsync(locale)
            } else {
                this.$i18n.locale = locale
            }

            this.$store.commit('i18n/setLocale', locale)
            localStorage.setItem('locale', locale)
        }
    }
}
</script>

<style lang="scss">
#nav {
    height: 60px;
    display: flex;
    justify-items: center;
    align-items: center;
    box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.35);

    .content {
        width: 100%;
        max-width: 1400px;
        display: block;
        margin: 0 auto;

        .logo {
            background-image: url('../../../public/img/logo.png');
            background-size: 100%;
            background-position: center center;
            background-repeat: no-repeat;
            height: 40px;
            width: 40px;
            margin-left: 26px;
            cursor: pointer;
            float: left;
        }

        .text {
            height: 100%;
            color: $black;
            font-size: 20px;
            margin-left: 30px;
            width: fit-content;
            float: left;
            line-height: 40px;

            b {
                font-family: Speedee-bd;
            }
        }

        .select-language {
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            float: right;
            height: 40px;
            font-size: 18px;
            margin-right: 26px;
            padding-right: 30px;
            background-size: 18px;
            background-repeat: no-repeat;
            background-position: right 5px center;
            background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
        }
    }

    @media screen and (max-width: 720px) {
        .content {
            .logo {
                height: 30px;
                width: 30px;
                margin-left: 10px;
            }

            .text {
                margin-left: 10px;
                font-size: 16px;
                line-height: 30px;
            }
        }
    }
}
</style>
